import { FormElement } from "models/forms/formElements/FormElement";
import { FormElementType } from "models/forms/formElements/FormElementType";
import { TextboxElement } from "models/forms/formElements/TextboxElement";
import React, { useEffect, useState } from "react";
import FormElementRenderer from "./formElements/FormElementRenderer";
import { ApiService } from "services/ApiService";

// Props for the FormElementList
interface FormElementListProps { // List of form elements to display
  formElements: FormElement[];
  onSubmit: (elements: FormElement[]) => void;
  isDisabled?: boolean;
}

const FormElementList: React.FC<FormElementListProps> = ({ formElements, onSubmit, isDisabled }) => {

  const [elements, setElements] = useState<FormElement[]>(() => [...(formElements ?? [])]);

  useEffect(() => {
    setElements([...(formElements ?? [])]);
  }, [formElements]);

  const handleUpdateElement = (updatedElement: FormElement) => {
    const updated = elements.map((el) => (el.id === updatedElement.id ? updatedElement : el));
    setElements(updated);
    onSubmit(updated);
  };

  return (
    <div>
        <>
          <ul>
            {elements
              .slice()
              .sort((a, b) => a.index - b.index)
              .map((element) => (
              <li key={element.id}>
                <FormElementRenderer
                  onUpdate={handleUpdateElement}
                  element={element}
                  isEditing={false} 
                  isDisabled={isDisabled ?? false}
                  onDelete={function (id: string): void {
                    throw new Error("Function not implemented.");
                  } }                
                />
              </li>
            ))}
          </ul>
        </>
    </div>
  );
};
export default FormElementList;